import { createQueryKeys } from "@lukemorales/query-key-factory";
import { useQuery } from "@tanstack/vue-query";
import { ProductsApi } from "mws-ts-v2-sdk";

import { getUniversalAxios } from "~/utils/axios/getUniversalAxios";

const getProductsApi = () => {
  return new ProductsApi(
    undefined,
    useRuntimeConfig().public.catalogServiceUrl,
    getUniversalAxios(),
  );
};

export const matchScoredBallsQueryKey = createQueryKeys("matchScoredBalls", {
  matchScoredBalls: (
    categoryId: MaybeRef<string>,
    params: {
      numberOfProducts: MaybeRef<number>;
      platformId: MaybeRef<string>;
    },
  ) => ({
    queryKey: [categoryId, params.numberOfProducts],
    queryFn: async () => {
      const response =
        await getProductsApi().v2ProductsMatchScoredBallsCategoryCategoryIdGet({
          categoryId: unref(categoryId),
          xPlatformKey: unref(params.platformId),
          numberOfProducts: unref(params.numberOfProducts),
        });

      return response.data;
    },
  }),
});

export const useMatchScoredBallsQuery = (categoryId: Ref<string>) => {
  const platformStore = usePlatformStore();
  const platformId = computed(
    () => platformStore.getPlatformConfiguration.platformId,
  );

  return useQuery({
    ...matchScoredBallsQueryKey.matchScoredBalls(categoryId, {
      numberOfProducts: 4,
      platformId,
    }),
    refetchInterval: (query) => {
      const shouldRefetch = query.state.data?.showMatchScoredBalls;

      return shouldRefetch ? 60000 : false; // refetch every minute - 60000ms
    },
  });
};
